import { GridRenderCellParams } from '@mui/x-data-grid-premium';
import { companyConfigService } from '../../../../../../../../shared/services/companyConfig/companyConfig.service';
import { IProductionListProps } from '../../productionList.component';
import {
  ReportPreviewStatus,
  statusWorkerState,
} from '../../../../../states/statusWorker/statusWorker.state';
import { printJobsDetailsState } from '../../../../../states/printJobsDetails.state';
import { JSX, useEffect, useState } from 'react';
import { PrintButton } from './printButton.component';

export const usePrint = (args: TUsePrintArgs): IUsePrintResult => {
  const { previewListStatus, datePeriod } = args;
  const [shouldAutoPrintRow, setShouldAutoPrintRow] = useState<string | null>(null);
  const isPrintingAvailable = companyConfigService.getCachedConfigs()?.isPrintingAvailable;

  // Auto-print report when it is ready to print
  useEffect(() => {
    if (shouldAutoPrintRow) {
      const reportStatus = previewListStatus.find((item) => item.uuid === shouldAutoPrintRow);
      if (
        reportStatus &&
        (reportStatus.status === ReportPreviewStatus.ready ||
          reportStatus.status === ReportPreviewStatus.viewed) &&
        reportStatus.url
      ) {
        setShouldAutoPrintRow(null);
        printJobsDetailsState.pub.printProductionReports([
          {
            productionPrintListId: reportStatus.uuid,
            onDate: datePeriod.fromDate,
            pdfUrl: reportStatus.url,
          },
        ]);
      }
    }
  }, [shouldAutoPrintRow, previewListStatus, datePeriod.fromDate]);

  const renderPrintCell = ({ row }: GridRenderCellParams) => {
    const {
      status: previewStatus,
      uuid,
      url,
    } = previewListStatus?.find((item) => item.uuid === row.id) || {};

    const status = previewStatus || ReportPreviewStatus.disabled;

    const handlePrintOnRow = () => {
      const isData = uuid && url;
      if (isData) {
        // PDF is ready to print
        printJobsDetailsState.pub.printProductionReports([
          {
            productionPrintListId: uuid,
            onDate: datePeriod.fromDate,
            pdfUrl: url,
          },
        ]);
      } else if (uuid && row?.reportId) {
        // PDF is not downloaded - first download, then auto-print
        setShouldAutoPrintRow(uuid);
        statusWorkerState.pub.itemAction({ uuid, reportId: row.reportId });
      }
    };

    return <PrintButton status={status} onClick={handlePrintOnRow} />;
  };

  return { isPrintingAvailable, renderPrintCell };
};

type TUsePrintArgs = Pick<IProductionListProps, 'previewListStatus' | 'datePeriod'>;

interface IUsePrintResult {
  isPrintingAvailable?: boolean;
  renderPrintCell: ({ row }: GridRenderCellParams) => JSX.Element | null;
}
